import { TABLE_EMPTY_CELL } from "../../utils/tableDisplayUtils";
import { normalizeTaskType } from "../../helpers/taskUpdateHelper";

export const FREQUENCY_LABELS = {
  daily: "Daily",
  weekly: "Weekly",
  bi_weekly: "Bi-weekly",
  monthly: "Monthly",
  quarterly: "Quarterly",
  semi_annually: "Semi-annually",
  annually: "Annually",
};

export function frequencyLabel(freq) {
  if (freq == null || freq === "") return TABLE_EMPTY_CELL;
  const s = String(freq).trim();
  if (!s) return TABLE_EMPTY_CELL;
  return FREQUENCY_LABELS[s] ?? s;
}

export function taskTypeLabel(taskType) {
  return normalizeTaskType(taskType) === "recurring" ? "Recurring" : "Single";
}

export function subPhaseName(sub) {
  if (!sub || typeof sub !== "object") return "";
  return sub.name ?? sub.sub_phase?.name ?? "";
}
